import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  toolbar: {
    marginBottom: '1rem',
  },

  tableWrapper: {
    '& th': {
      whiteSpace: 'normal !important',
      textAlign: 'center',
    },
  },

  dimensionAnomaly: {
    color: t.red01,
    fontWeight: 'bold',
  },
}))
